/* eslint-disable no-underscore-dangle */
import { Col, Row, Switch } from 'antd';
import { Form, Formik } from 'formik';
import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { carColorValidationSchema } from './carColor.schema';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import FormInput from '../../../components/input/input';
import { DEFAULT_LANG, LANGUAGE_BY_DOMAIN } from '../../../utils/constants';
import { addNewColor, editCarColor, getAllColors } from '../../../redux/car color/actionCreator';
import DivBreak from '../../../components/divBreak/DivBreak';

const CarColorForm = props => {
  const { formData, onCancel } = props;
  const dispatch = useDispatch();

  const carColorLoading = useSelector(state => state.carColor.loading);

  const [isMultiLangFlag, setIsMultiLangFlag] = useState(false);

  useEffect(() => {
    setIsMultiLangFlag(formData?.isMultiLang.includes('true'));
  }, [formData]);

  async function handleFormSubmit(requestData, resetForm) {
    try {
      const transformedColors = [];
      LANGUAGE_BY_DOMAIN.forEach(langItem => {
        if (requestData.isMultiLang === 'true' || langItem[1] === DEFAULT_LANG.value) {
          transformedColors.push({
            lang: langItem[1],
            color: requestData[`color${langItem[1]}`],
          });
        }
      });

      const formValue = {
        details: transformedColors,
      };

      // eslint-disable-next-line no-underscore-dangle
      const res = await dispatch(requestData?._id ? editCarColor(requestData?._id, formValue) : addNewColor(formValue));
      if (res?.data?.status) {
        resetForm();
        onCancel();
        getAllColors(dispatch);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }

  return (
    <Formik
      initialValues={formData}
      validationSchema={carColorValidationSchema(isMultiLangFlag)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        // eslint-disable-next-line no-use-before-define
        handleFormSubmit(values, resetForm);
      }}
      enableReinitialize
    >
      {({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
          <Form>
            <BasicFormWrapper>
              <div className="add-product-block">
                <Row gutter={[16, 16]}>
                  {/* language switcher */}
                  <Col xs={24}>
                    <h4>Translate</h4>
                    <Switch
                      checked={values.isMultiLang === 'true'}
                      onChange={checked => {
                        setFieldValue('isMultiLang', String(checked));
                        setIsMultiLangFlag(checked);
                      }}
                    />
                  </Col>

                  {/* body type default  */}
                  <Col xs={24}>
                    <FormInput
                      name={`color${DEFAULT_LANG.value}`}
                      label={`Body Color (${DEFAULT_LANG.label})`}
                      value={values[`color${DEFAULT_LANG.value}`]}
                      handleChange={handleChange}
                      placeholder="Body Color"
                      errors={errors}
                      touched={touched}
                    />
                  </Col>

                  {/* body type dynamic  */}
                  {values.isMultiLang === 'true' &&
                    LANGUAGE_BY_DOMAIN.filter(item => DEFAULT_LANG.value !== item[1]).map(([label, value], index) => {
                      return (
                        <Col xs={24} key={index}>
                          <FormInput
                            name={`color${value}`}
                            label={`Body Color (${label})`}
                            value={values[`color${value}`]}
                            handleChange={handleChange}
                            placeholder="Body Color"
                            errors={errors}
                            touched={touched}
                          />
                        </Col>
                      );
                    })}
                </Row>
              </div>

              <DivBreak />

              <Row justify="end" align="middle">
                <Col>
                  <Button
                    style={{
                      backgroundColor: '#155BDC',
                      color: '#fff',
                      marginRight: 5,
                      height: '40px',
                      fontWeight: '500',
                    }}
                    htmlType="submit"
                    loading={carColorLoading}
                  >
                    {values?._id ? 'Edit Body Color' : 'Add Body Color'}
                  </Button>
                  <Button size="default" type="white" key="back" outlined onClick={onCancel}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </BasicFormWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

CarColorForm.propTypes = {
  formData: propTypes.object,
  onCancel: propTypes.func,
};

export default CarColorForm;
